export default __webpack_public_path__ + "static/media/unknown-bank.e50abffb.svg";